import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { value: "" }
const _hoisted_4 = { value: "CASH" }
const _hoisted_5 = { value: "BANK_TRANSFER" }
const _hoisted_6 = { value: "CHECK" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { value: "" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { value: "" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "form-actions" }

import { ref, watch, PropType, computed } from 'vue';
import AppButton from '@/components/base/AppButton.vue';
import AppModal from '@/components/base/Modal.vue';
import type { ExpenseData, Intervenant } from '@/types/services';

interface TaskWithIntervenant {
  id: string;
  name: string;
  intervenantId?: string;
  intervenantName: string;
  [key: string]: any;
}

interface Emits {
  (e: 'cancel'): void;
  (e: 'submit', payload: { data: FormDataType; isValid: boolean }): void;
}

interface FormDataType {
  amount: number | null;
  description: string;
  paymentType: string;
  transactionDate: string;
  invoice: File | null;
  intervenantId: string | null;
  taskId: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RecordExpenseModal',
  props: {
  isVisible: { type: Boolean as PropType<boolean>, default: false },
  tasks: { type: Array as PropType<TaskWithIntervenant[]>, default: () => [] },
  intervenants: { type: Array as PropType<Intervenant[]>, default: () => [] },
  expense: { type: Object as PropType<ExpenseData | null>, default: null },
  isEditMode: { type: Boolean as PropType<boolean>, default: false }
},
  emits: ["cancel", "submit"],
  setup(__props, { emit: __emit }) {

/// <reference types="vue" />
// @ts-ignore
const props = __props;

const emit = __emit;

// Form data
const formData = ref<FormDataType>({
  amount: null,
  description: '',
  paymentType: '',
  transactionDate: new Date().toISOString().split('T')[0],
  invoice: null,
  intervenantId: null,
  taskId: null
});

// Computed property to filter tasks by selected intervenant
const filteredTasks = computed(() => {
  if (!formData.value.intervenantId) {
    return [];
  }
  return props.tasks.filter((task: TaskWithIntervenant) => task.intervenantId === formData.value.intervenantId);
});

// Methods
const handleIntervenantChange = () => {
  // Clear task selection when intervenant changes
  formData.value.taskId = null;
};

const handleCancel = () => {
  resetForm();
  emit('cancel');
};

const handleSubmit = () => {
  // Validate required fields
  if (!formData.value.amount || !formData.value.paymentType || !formData.value.intervenantId || !formData.value.transactionDate) {
    // Parent component should handle validation error display
    emit('submit', { data: formData.value, isValid: false });
    return;
  }
  
  emit('submit', { data: formData.value, isValid: true });
};

const handleInvoiceUpload = (event: Event) => {
  const target = event.target as HTMLInputElement;
  formData.value.invoice = target.files?.[0] || null;
};

const resetForm = () => {
  if (props.isEditMode && props.expense) {
    // Initialize with existing expense data for editing
    formData.value = {
      amount: props.expense.amount || null,
      description: props.expense.description || '',
      paymentType: props.expense.paymentType || '',
      transactionDate: props.expense.transactionDate || new Date().toISOString().split('T')[0],
      invoice: null, // File input will be empty for editing
      intervenantId: props.expense.intervenantId || null,
      taskId: props.expense.taskId || null
    };
  } else {
    // Initialize with empty data for new expense
    formData.value = {
      amount: null,
      description: '',
      paymentType: '',
      transactionDate: new Date().toISOString().split('T')[0],
      invoice: null,
      intervenantId: null,
      taskId: null
    };
  }
  
  // Reset file input
  const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
  if (fileInput) {
    fileInput.value = '';
  }
};

// Watch for visibility changes to reset form when modal is opened
watch(() => props.isVisible, (newVal: boolean) => {
  if (newVal) {
    resetForm();
  }
});

// Watch for expense changes to populate form when editing
watch(() => props.expense, (newExpense: any) => {
  if (props.isEditMode && newExpense) {
    resetForm();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(AppModal, {
      isVisible: __props.isVisible,
      title: __props.isEditMode ? _ctx.$t('finance.editExpense') : _ctx.$t('finance.recordExpense'),
      onCancel: handleCancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleSubmit, ["prevent"]),
          class: "finance-form"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('finance.amount')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.amount) = $event)),
              step: "0.01",
              required: "",
              class: "form-input"
            }, null, 512), [
              [_vModelText, formData.value.amount]
            ])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('finance.paymentType')), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.paymentType) = $event)),
              required: "",
              class: "form-input"
            }, [
              _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.$t('finance.selectPaymentType')), 1),
              _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.$t('finance.paymentTypes.cash')), 1),
              _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$t('finance.paymentTypes.bankTransfer')), 1),
              _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t('finance.paymentTypes.check')), 1)
            ], 512), [
              [_vModelSelect, formData.value.paymentType]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('finance.intervenant')) + " *", 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.intervenantId) = $event)),
              class: "form-input",
              required: "",
              onChange: handleIntervenantChange
            }, [
              _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t('finance.selectIntervenant')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.intervenants, (intervenant) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: intervenant.id,
                  value: intervenant.id
                }, _toDisplayString(intervenant.name), 9, _hoisted_9))
              }), 128))
            ], 544), [
              [_vModelSelect, formData.value.intervenantId]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('finance.task')), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.taskId) = $event)),
              class: "form-input",
              disabled: !formData.value.intervenantId
            }, [
              _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('finance.selectTask')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTasks.value, (task) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: task.id,
                  value: task.id
                }, _toDisplayString(task.name), 9, _hoisted_13))
              }), 128))
            ], 8, _hoisted_11), [
              [_vModelSelect, formData.value.taskId]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('finance.transactionDate')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.transactionDate) = $event)),
              required: "",
              class: "form-input"
            }, null, 512), [
              [_vModelText, formData.value.transactionDate]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('finance.description')), 1),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.description) = $event)),
              class: "form-input"
            }, null, 512), [
              [_vModelText, formData.value.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('finance.invoice')), 1),
            _createElementVNode("input", {
              type: "file",
              onChange: handleInvoiceUpload,
              accept: ".pdf,.jpg,.jpeg,.png",
              class: "form-input"
            }, null, 32)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(AppButton, {
              type: "button",
              variant: "outline",
              onClick: handleCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
              ]),
              _: 1
            }),
            _createVNode(AppButton, {
              type: "submit",
              variant: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
              ]),
              _: 1
            })
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["isVisible", "title"])
  ]))
}
}

})